export const inview = (selector, options) => {
  const els = document.querySelectorAll(selector);

  const cb = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add("inview-is-visible");
          observer.unobserve(entry.target);
        }, 10);
      }
    });
  };

  const io = new IntersectionObserver(cb, options);

  els.forEach((el) => {
    io.observe(el);
  });
};
